import { ISO8601 } from '@alk/dates';

export async function wait(time: number): Promise<void> {
    return new Promise<void>((resolve) => {
        setTimeout(() => {
            resolve();
        }, time);
    });
}

export function now(): ISO8601 {
    return (new Date()).toISOString() as ISO8601;
}
